






import Vue from 'vue';

const posesMap = require('@/data/poses.json');

export default Vue.extend({
  name: 'PoseIcon',
  props: {
    alt: String,
    name: String,
    practiceStyle: String,
    side: String,
  },
  data() {
    return {
      poseAlt: '',
      poseUrl: '',
    };
  },
  created() {
    this.poseAlt = this.name;

    if (this.alt !== '') {
      this.poseAlt = this.alt;
    }

    // Construct pose URL
    this.poseUrl = this.poseImage(this.name, this.side);
  },
  methods: {
    poseImage(name: string, side: string) {
      const sides: { [key: string]: string } = {
        left: '_L',
        right: '_R',
      };

      for (let i = 0; i < posesMap.length; i += 1) {
        if (posesMap[i].name === name) {
          let image: string = posesMap[i].name.replace(/\s+/g, '');

          if (posesMap[i].two_sided || posesMap[i].sideways) {
            image += sides[side];
          }

          return `${image}-tn146.png`;
        }
      }

      // Default to custom pose if we didn't find the image
      return 'custom_pose.png';
    },
  },
});
